import { render, staticRenderFns } from "./suggestion_diff.vue.js?vue&type=template&id=0d297972!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./suggestion_diff.vue?vue&type=template&id=0d297972"
import script from "./suggestion_diff.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./suggestion_diff.vue?vue&type=script&lang=js"
export * from "./suggestion_diff.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./suggestion_diff.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports